<template>
<section class="hero is-primary is-fullheight is-fullwidth">
  <div class="hero-body">
    <div  class="container">
      <div class="columns is-centered">
        
        <div class="column is-full-mobile  is-8-tablet is-7-desktop is-6-widescreen">
         <div class="text-welcome" v-if="!valid">
          <p>Invalid reset password link.</p>
          <br>
          </div>
          <div v-if="valid">
          <figure style="width:250px; height:50px; margin:auto;"> 
            <img src="https://smartgoalstraining.com/skillgames-api/online-img/logo.png">
          </figure>
          <div class="text-welcome">
          <p>You seem to have forgotten the password for <strong>{{this.user.username}}</strong>.</p>
          <p>Fill in a new one and you can get back in.</p>
          <br>
          </div>
          <form  class="box" >
            <div class="field">
              <label for="" class="label"></label>
              <div class="control has-icons-left">
                <input  type="password" placeholder="Create password" class="input" ref="password" >
                <span class="icon is-small is-left">
                  <font-awesome-icon :icon="[ 'fas','lock']" />
                </span>
              </div>
            </div>
            <div class="field">
              <label for="" class="label"></label>
              <div class="control has-icons-left">
                <input type="password" placeholder="Confirm password" class="input" ref="passwordConfirm" >
                <span class="icon is-small is-left">
                  <font-awesome-icon :icon="[ 'fas','lock']" />
                </span>
              </div>
            </div>
            <p ref="message" style="color:red;"> </p>
            <div class="field" style="margin-top:20px;">
              <button type="button" class="button orangebtn is-fullwidth" v-on:click="updatePassword()">
                Activate
              </button>
            </div>

          </form>
        </div>
      </div>
      </div>
    </div>
  </div>
</section>
</template>
<script>
import $ from "jquery";
import {faLock} from '@fortawesome/free-solid-svg-icons'
import {library} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
library.add(faLock)

export default {
  name: "ForgotPassword",
  data: function() {
    return {
      valid: false,
      user: {}
    };
  },
  components: { FontAwesomeIcon},
  props: ["id"],
  computed: {
  },
  methods: {
    updatePassword() {

        if(this.$refs.password.value!='' && this.$refs.passwordConfirm.value!=''){
        if(this.$refs.password.value.length>=8) 
        {
        if(this.$refs.password.value === this.$refs.passwordConfirm.value)
        {
        $.ajax({
        type: "POST",
        async: false,
        url: this.$APIlink + "password/reset",
        data: {username: this.user.username, password: this.$refs.password.value, c_password: this.$refs.passwordConfirm.value, token: this.user.token},
        success: (data, status) => {
          if(status == 'success')
          {
          this.$router.push({name:'Success'}); 
          }
          else this.$refs.message.innerText="There was an error while reseting your password.";
        }, 
        error: function() {
        }
        
      })
        }
        else  {
          this.$refs.message.innerText="Passwords don't match.";
        }
        }
        else  {
          this.$refs.message.innerText="Password should be at least 8 symbols.";
        }
        } else
        {
          this.$refs.message.innerText="Please enter both fields.";
        }
        
    }, 
  },
  mounted: function() {
      $.ajax({
        type: "GET",
        async: false,
        url: this.$APIlink + "password/find/"+this.id,
        success: (data, status) => {
          if(status == 'success')
          {
              this.valid=true;
              this.user=data
          }
          else this.valid=false;
          
        }, 
        error: function() {
          this.valid=false;
        }
      })
  }
};
</script>
